export default __webpack_public_path__ + "023c8799626e5b0a8997501f7defda3a.png";